export const AUTH_API_URL = '/api/auth';
export const IAM_API_URL = '/api/iam';
export const LAB_RESULTS_API_URL = '/api/lab';
export const APPOINTMENT_AUTH_API_URL = '/api/appointment';

export const CONSULT_API_URL = '/api/v3/consult';
export const HEALTH_SUMMARY_API_URL = '/api/health-summary';
export const SEARCH_API_URL = '/api/search';

export const FILE_API_URL = '/api/file';
export const EMC_API_URL = '/api/emc';
export const PRESCRIPTION_API_URL = '/api/prescription';

export const ACCOUNT_MANAGEMENT_API_URL = '/api/account-management';
export const EMR_API_URL = '/api/emr';
export const ALERT_API_URL = '/api/alert';
export const NOTIFICATION_API_URL = '/api/notification';

export const INVOICE_API_URL = '/api/invoice';

export const REPORT_API_URL = '/api/report';
export const MANAPAY_API_URL = '/api/manapay';
export const MARKETPLACE_API_URL = '/api/marketplace';
export const AI_API_URL = '/api/ai';
